import LOCATION_TYPE from '../../enum/location_type';
import { loadStoreLocationOptions, uniqueNames } from '../../grid/storeLocationFilter';

/** Must match API `DISPENSING_LOCATION_SQL` / portal `formatDispensingLocation` separator. */
export const DISPENSING_LOCATION_SEPARATOR = ' – ';

/**
 * Channel labels must match lookup.locationtype_master.name (Stage / DISPENSING_LOCATION_SQL).
 */
export const CHANNEL_NAME_BY_LOCATION_TYPE_ID = {
  [LOCATION_TYPE.Kiosk]: 'Kiosk',
  [LOCATION_TYPE.Counter]: 'Counter',
  [LOCATION_TYPE.Bedside]: 'Bedside',
  [LOCATION_TYPE.Curbside]: 'Cur b Side',
  [LOCATION_TYPE.Courier]: 'Courier',
  [LOCATION_TYPE.Other]: 'Other',
  [LOCATION_TYPE.Home]: 'Home',
  [LOCATION_TYPE.Work]: 'Work',
};

export function formatCompositeDispensingLocation(storeName, channelName) {
  const store = storeName == null ? '' : String(storeName).trim();
  const channel = channelName == null ? '' : String(channelName).trim();
  if (store && channel) {
    return `${store}${DISPENSING_LOCATION_SEPARATOR}${channel}`;
  }
  return store || channel || '';
}

export function channelNameForConfiguredBox(box) {
  if (!box) return '';
  const typeId = box.location_type_id;
  if (!typeId) return '';
  return CHANNEL_NAME_BY_LOCATION_TYPE_ID[typeId] || '';
}

/**
 * Configured Manage Locations → composite labels (store + channel), deduped.
 */
export function buildConfiguredDispensingLocationOptions(stores, boxes) {
  const storeById = new Map();
  (stores || []).forEach((row) => {
    if (row && row.id != null) {
      storeById.set(row.id, row.name != null ? String(row.name).trim() : '');
    }
  });

  const composites = [];
  (boxes || []).forEach((box) => {
    const accountId = box && box.parent_account_id;
    const channel = channelNameForConfiguredBox(box);
    if (!channel) return;
    const storeName =
      (accountId != null && storeById.get(accountId)) ||
      (box.account && box.account.name) ||
      '';
    if (!storeName) return;
    const composite = formatCompositeDispensingLocation(storeName, channel);
    if (composite) composites.push(composite);
  });

  return uniqueNames(composites);
}

/**
 * Supplemental options from API row field only (matches DISPENSING_LOCATION_SQL).
 * Does not use valueGetter — display may localize channel names.
 */
export function namesFromDispensingLocationGrid(api) {
  if (!api || typeof api.forEachNode !== 'function') return [];
  const names = [];
  api.forEachNode((node) => {
    const data = node && node.data;
    if (!data) return;
    if (data.dispensing_location != null && String(data.dispensing_location).trim()) {
      names.push(String(data.dispensing_location).trim());
    }
  });
  return uniqueNames(names);
}

/**
 * Option C: configured locations + values from loaded SSRM rows (API composites).
 */
export function mergeDispensingLocationOptionNames(configured, fromReport) {
  return uniqueNames((configured || []).concat(fromReport || []));
}

export function resolveControlledSubstanceDispensingLocationOptions(api) {
  return loadStoreLocationOptions().then((options) => {
    const configured = buildConfiguredDispensingLocationOptions(
      options.stores,
      options.locations
    );
    const fromReport = namesFromDispensingLocationGrid(api);
    return mergeDispensingLocationOptionNames(configured, fromReport);
  });
}

export function isCompositeDispensingLocationLabel(name) {
  return String(name).includes(DISPENSING_LOCATION_SEPARATOR);
}



// WEBPACK FOOTER //
// ./src/components/reports/controlled-substance-dispensed/controlledSubstanceDispensingLocationOptions.js